export interface RateAgreementBidPack {
  Id: number;
  DestinationName: string;
  Name: string;
}

export const defaultRateAgreementBidPack: RateAgreementBidPack = {
  Id: 0,
  DestinationName: "",
  Name: "",
};
